import styled from 'styled-components';
import { spacing } from '../../../theme';

export const StyledWhenSection = styled.div`
  margin-top: ${spacing('xl3')};
`;
